// extracted by mini-css-extract-plugin
export default {"errorUi":"ErrorUI_errorUi__zyrRx","heading":"ErrorUI_heading__WI+gj","message":"ErrorUI_message__I5SJw"};